package com.mps.asc_app.util

import kotlinx.browser.document
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

actual fun exportCsv(filename: String, csvText: String): Boolean {
    return try {
        val blob = Blob(arrayOf(csvText), BlobPropertyBag(type = "text/csv;charset=utf-8"))
        val url = URL.createObjectURL(blob)
        val a = (document.createElement("a") as HTMLAnchorElement).apply {
            href = url
            download = filename
            style.display = "none"
        }
        document.body?.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(url)
        true
    } catch (_: Throwable) {
        false
    }
}

